'use strict';

var FaresOptimizerUndoModalController = function FaresOptimizerUndoModalController($scope, configurationService) {
  $scope.notes = '';
  $scope.undoOptions = configurationService.getFoRejectionReasons(); //TODO:have to change this to undooptions

  $scope.handleUndo = function () {
    $scope.stateChangeModal.authorizationNotes = $scope.notes;
    if ($scope.fareLadderUndoKeyList) $scope.stateChangeModal.fareLadderUndoKeyList = $scope.fareLadderUndoKeyList;
    $scope.stateChangeModal.fareRecommendationUndoKeyList = $scope.fareRecommendationUndoKeyList;
    $scope.undoCallback();
  };
  $scope.handleUndoState = function () {
    $scope.notes = '';
  };
  $scope.isFormDisabled = function () {
    return $scope.notes === undefined || $scope.notes === '';
  };
};
FaresOptimizerUndoModalController.$inject = ['$scope', 'ConfigurationService'];
module.exports = FaresOptimizerUndoModalController;